import { render, staticRenderFns } from "./ProjectLinker.vue?vue&type=template&id=29074fb2&"
import script from "./ProjectLinker.vue?vue&type=script&lang=js&"
export * from "./ProjectLinker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports